/* DerbyLys – door projection preview. Listens to the product section for motifs. */
(() => {
  'use strict';
  const S = () => (window.PG && window.PG.strings) || {};

  const hexToRgba = (hex, a) => {
    const m = String(hex || '').replace('#', '').match(/^([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (!m) return `rgba(56,189,248,${a})`;
    let h = m[1];
    if (h.length === 3) h = h.split('').map((c) => c + c).join('');
    const n = parseInt(h, 16);
    return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
  };

  class Preview {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('[data-stage]');
      this.chips = root.querySelector('[data-preview-chips]');
      this.toggle = root.querySelector('[data-door-toggle]');
      this.status = root.querySelector('[data-stage-status]');
      this.abbr = root.querySelector('[data-stage-abbr]');
      this.logo = root.querySelector('[data-stage-logo]');
      this.open = false;
      this.team = null;
      this.teams = [];

      this.toggle?.addEventListener('click', () => { this.userTouched = true; this.setDoor(!this.open); });

      document.addEventListener('pg:teams', (e) => this.setTeams(e.detail.teams, e.detail.selected));
      document.addEventListener('pg:team-change', (e) => this.setTeam(e.detail.team, false));
      document.dispatchEvent(new CustomEvent('pg:request-teams'));

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (root.dataset.autoOpen !== 'false' && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => entries.forEach((en) => {
          if (en.isIntersecting && !this.userTouched) {
            io.disconnect();
            setTimeout(() => { if (!this.userTouched) this.setDoor(true); }, reduce ? 0 : 450);
          }
        }), { threshold: 0.35 });
        io.observe(this.stage);
      }
    }

    setTeams(teams, selected) {
      this.teams = teams || [];
      if (!this.chips) return;
      this.chips.innerHTML = '';
      this.chips.hidden = this.teams.length < 2;
      this.teams.forEach((t) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.dataset.team = t.name;
        const dot = document.createElement('span');
        dot.className = 'chip__dot';
        dot.style.background = t.c1;
        dot.style.boxShadow = `inset 0 0 0 2.5px ${t.c2}`;
        b.append(dot, document.createTextNode(t.name));
        b.addEventListener('click', () => {
          this.userTouched = true;
          this.setTeam(t, true);
          if (!this.open) this.setDoor(true);
        });
        this.chips.appendChild(b);
      });
      const sel = this.teams.find((t) => t.name === selected) || this.teams[0];
      if (sel) this.setTeam(sel, false);
    }

    setTeam(team, fromChip) {
      if (!team || !team.name) return;
      const full = this.teams.find((t) => t.name === team.name) || team;
      this.team = full;
      if (this.stage && full.c1) {
        this.stage.style.setProperty('--c1', full.c1);
        this.stage.style.setProperty('--c2', full.c2 || '#0F172A');
        this.stage.style.setProperty('--glow', hexToRgba(full.c1, 0.33));
      }
      if (this.abbr) this.abbr.textContent = full.abbr || full.name.slice(0, 3).toUpperCase();
      if (this.logo) {
        const has = !!full.logo;
        if (has && this.logo.getAttribute('src') !== full.logo) this.logo.src = full.logo;
        this.logo.alt = has ? full.name : '';
        this.logo.hidden = !has;
        this.stage?.classList.toggle('has-logo', has);
      }
      this.chips?.querySelectorAll('.chip').forEach((c) => {
        const on = c.dataset.team === full.name;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', String(on));
      });
      this.renderStatus();
      if (fromChip) document.dispatchEvent(new CustomEvent('pg:select-team', { detail: { name: full.name } }));
    }

    setDoor(open) {
      this.open = open;
      this.stage?.classList.toggle('is-open', open);
      if (this.toggle) {
        this.toggle.setAttribute('aria-pressed', String(open));
        const lab = this.toggle.querySelector('[data-door-label]');
        if (lab) lab.textContent = open ? S().closeDoor : S().openDoor;
        const ic = this.toggle.querySelector('[data-door-icon-closed]');
        const io = this.toggle.querySelector('[data-door-icon-open]');
        if (ic) ic.hidden = open;
        if (io) io.hidden = !open;
      }
      this.renderStatus();
    }

    renderStatus() {
      if (!this.status) return;
      const s = S();
      this.status.textContent = this.open ? `${s.doorOpen}${this.team ? ' · ' + this.team.name : ''}` : s.doorClosed;
    }
  }

  const init = () => document.querySelectorAll('[data-preview]').forEach((el) => { if (!el.__pg) el.__pg = new Preview(el); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
